module.exports = __webpack_public_path__ + "assets/1fbc9c24c1f84bb7b6b8e739035d735a.woff2";